// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RxntPostResponse } from './rxnt-post-response';

/** See com.rev360.pms.api.controller.rxnt.LaunchRxntResponse */
/* istanbul ignore next */
@GandalfModel
export class LaunchRxntResponse extends GandalfModelBase {

	@GandalfProperty({ designType: RxntPostResponse })
	postObject!: RxntPostResponse | null;

	@GandalfProperty({ designType: String })
	postUrl!: string | null;

}
